import {
    DEPOSIT_INTEREST_LOADING_TOGGLE,
    ADD_INTEREST_PAYMENT_SUCCESS,
    ADD_INTEREST_PAYMENT_FAILED,
    GET_INTEREST_PAYMENTS_SUCCESS,
    GET_INTEREST_PAYMENTS_FAILED,
    GET_INTEREST_PAYMENT_BY_ID_SUCCESS,
    GET_INTEREST_PAYMENT_BY_ID_FAILED,
    GET_INTEREST_SUMMARY_SUCCESS,
    GET_INTEREST_SUMMARY_FAILED,
    GET_DEPOSITORS_FOR_INTEREST_SUCCESS,
    GET_DEPOSITORS_FOR_INTEREST_FAILED,
    CLEAR_DEPOSIT_INTEREST_ERRORS,
    RESET_DEPOSIT_INTEREST_SUCCESS
} from "../actions/DepositInterestActions";

const initialState = {
    list: [],
    data: {},
    summary: {},
    depositors: [],
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        recordsPerPage: 10,
        hasNextPage: false,
        hasPreviousPage: false
    },
    loading: false,
    error: null,
    success: null
};

const DepositInterestReducer = (state = initialState, action) => {
    switch (action.type) {
        case DEPOSIT_INTEREST_LOADING_TOGGLE:
            return { ...state, loading: action.payload };
        case ADD_INTEREST_PAYMENT_SUCCESS:
            return { 
                ...state, 
                data: action.payload.data, 
                success: action.payload.message, 
                error: null 
            };
        case ADD_INTEREST_PAYMENT_FAILED:
            return { ...state, error: action.payload };
        case GET_INTEREST_PAYMENTS_SUCCESS:
            return {
                ...state,
                list: action.payload.data || [],
                pagination: action.payload.pagination || initialState.pagination,
                error: null
            };
        case GET_INTEREST_PAYMENTS_FAILED:
            return { ...state, error: action.payload };
        case GET_INTEREST_PAYMENT_BY_ID_SUCCESS:
            return { ...state, data: action.payload.data, error: null };
        case GET_INTEREST_PAYMENT_BY_ID_FAILED:
            return { ...state, error: action.payload };
        case GET_INTEREST_SUMMARY_SUCCESS:
            return { ...state, summary: action.payload.data || {}, error: null };
        case GET_INTEREST_SUMMARY_FAILED:
            return { ...state, error: action.payload };
        case GET_DEPOSITORS_FOR_INTEREST_SUCCESS:
            return { ...state, depositors: action.payload.data || [], error: null };
        case GET_DEPOSITORS_FOR_INTEREST_FAILED:
            return { ...state, error: action.payload };
        case CLEAR_DEPOSIT_INTEREST_ERRORS:
            return { ...state, error: null, success: null };
        case RESET_DEPOSIT_INTEREST_SUCCESS:
            return { ...state, success: null };
        default:
            return state;
    }
};

export default DepositInterestReducer;